<template>
  <ds-modal
    ref="modal"
    :title="title">
    <ds-row>
      <ds-col size="12">
        <ds-p color="grey-darkest">
          {{ introParagraph }}
        </ds-p>
        <br>
        <ds-row>
          <ds-col size="3" class="ds-u-align-self--center">
            <ds-illustration
              name="people-conversation"
              class="ds-u-width--full"></ds-illustration>
          </ds-col>
          <ds-col size="9">
            <ds-p weight="bold" color="blue">
              Admissão
              <ds-badge theme="info">
                não sincronizado
              </ds-badge>
            </ds-p>
            <ds-p color="blue-darkest">
              Toda admissão de funcionário(a) feita <ds-text weight="bold">após</ds-text> a data de
              obrigatoriedade da empresa no eSocial.
              Você pode consultar as datas
              <ds-external-link
                with-icon
                :href="LINK_ESOCIAL_DEPLOYMENT_SCHEDULE">
                no cronograma do eSocial.
              </ds-external-link>
            </ds-p>
            <br>
            <ds-p weight="bold" color="blue">
              Novo
              <ds-badge theme="info">
                não sincronizado
              </ds-badge>
            </ds-p>
            <ds-p color="blue-darkest">
              Toda admissão de funcionário(a) feita <ds-text weight="bold">após</ds-text> da data de
              obrigatoriedade da minha empresa no eSocial. Você pode consultar as datas
              <ds-external-link
                with-icon
                :href="LINK_ESOCIAL_DEPLOYMENT_SCHEDULE">
                no cronograma do eSocial.
              </ds-external-link>
            </ds-p>
            <br>
            <ds-p weight="bold" color="blue">
              Alterado
              <ds-badge theme="info">
                não sincronizado
              </ds-badge>
            </ds-p>
            <ds-p color="blue-darkest">
              Deve ser utilizado para envio de alterações adminissionais,
              contratuais ou cadastrais.
            </ds-p>
            <br>
            <ds-p weight="bold" color="blue">
              Sincronizado
            </ds-p>
            <ds-p color="blue-darkest">
              Toda admissão de funcionário(a) que já foi cadastrado no eSocial.
              Essa opção é apenas para registro na Conta Azul e não habilitará transmissão.
            </ds-p>
            <br>
            <ds-p weight="bold" color="blue">
              Reintegração
            </ds-p>
            <ds-p color="blue-darkest">
              Status utilizado para quando um funcionário(a) foi demitido indevidamente e
              precisa ser readmitido. Diferente de recontratação, é uma reintegração.
            </ds-p>
          </ds-col>
        </ds-row>
      </ds-col>
    </ds-row>
    <ds-footer justify="flex-end">
      <ds-button theme="primary" @click="$refs.modal.close()">
        Entendi
      </ds-button>
    </ds-footer>
  </ds-modal>
</template>

<script>
import { dialogService } from 'packages/common/ds-components';
import { LINK_ESOCIAL_DEPLOYMENT_SCHEDULE } from '../constants';

const ESocialSituationInfoModal = {
  name: 'ESocialSituationInfoModal',
  data() {
    return {
      LINK_ESOCIAL_DEPLOYMENT_SCHEDULE,
      introParagraph: 'A escolha da situação habilitará a transmissão do respectivo evento para o eSocial, caso seja aplicável.',
    };
  },
  computed: {
    title() {
      return 'Qual situação do cadastro no eSocial devo utilizar?';
    },
  },
};


ESocialSituationInfoModal.open = dialogService.buildOpenDialog(ESocialSituationInfoModal);

export default ESocialSituationInfoModal;
</script>
